import React from 'react';

import { Radio } from '@mui/material';

import { ControlBox, ControlBoxProps } from '../atoms/control-box';

type Props = {
  value: string;
} & ControlBoxProps;

export const RadioBox = ({ value, ...props }: Props) => {
  return (
    <ControlBox
      component="label"
      control={<Radio value={value} />}
      {...props}
    />
  );
};
